<template>
  <select v-model="selectedBrand" name="brands" @change="changeBrand($event)">
    <option v-for="brand in filteredBrands" :key="brand.value" :value="brand.urlValue">
      {{ brand.name }}
    </option>
  </select>
</template>

<script>
import brands from '@/helpers/enums/brands.js'

export default {
  data() {
    return {
      selectedBrand: brands.find((brand) => window.location.hostname.indexOf(brand.urlValue) > -1)
        ?.urlValue,
      brands: brands,
      filteredBrands: brands.filter(
        (brand) => window.location.hostname.indexOf(brand.urlValue) > -1 || brand.name !== 'Cupra'
      ),
    }
  },
  methods: {
    changeBrand(event) {
      for (const brand of brands) {
        const index = window.location.hostname.indexOf(brand.urlValue)

        if (index > -1) {
          const url = window.location.href.replace(brand.urlValue, event.target.value)
          window.open(url)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
select {
  appearance: none;
  height: 42px;
  min-width: 160px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  background-color: $white;
  padding: 0 38px 0 15px;
  font-size: 0.84rem;
  color: var(--color-text);
  cursor: pointer;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'><path d='M1 3l4 4 4-4' stroke='%23728186' stroke-width='1.4' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 14px center;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: $gray-light;
  }
  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px var(--color-primary-light);
  }
}
</style>
